import React, { useState } from 'react';
// Modal
import BookingItemFormModal from '../../../layouts/Modals/BookingItemFormModal';

const BookingItemsCreate = () => {
  const [ show, setShow ] = useState(false);
  return (
    <>
      <div className="form-group text-right">
        <button
          className="btn btn-primary btn-sm"
          type="button"
          onClick={() => setShow(true)}
        >Create</button>
      </div>
      {/* Modal */}
      {show &&
        <BookingItemFormModal
          show={show}
          onHide={() => setShow(false)}
        />
      }
    </>
  )
}

export default BookingItemsCreate;
